/**
 * Subtle text/content reveal on scroll for every [data-reveal] element.
 * CSS handles the transition; reduced-motion users see content immediately.
 */
export function initReveals(): void {
  const els = document.querySelectorAll<HTMLElement>('[data-reveal]');
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        (entry.target as HTMLElement).classList.add('is-visible');
        io.unobserve(entry.target);
      }
    }
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
  els.forEach(el => io.observe(el));
}

/** Footer local time (Europe/Amsterdam), updated every minute. */
export function initLocalTime(): void {
  const el = document.getElementById('local-time');
  if (!el) return;
  const fmt = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam',
  });
  const tick = () => { el.textContent = fmt.format(new Date()); };
  tick();
  setInterval(tick, 30_000);
}
